<p i18n="@@profileView.about.title" class="text-subtitle-1 u-marginBottom-16">
  About {{ profile?.first_name }}
</p>
<p
  *ngIf="!!profile.about"
  class="u-wordWrap-breakWord u-whiteSpace-preLine u-text-maxWidth color-grey"
>
  {{ profile.about }}
</p>
<div *ngIf="!profile.about && isUser">
  <button
    i18n="@@profileView.about.editLabel"
    class="c-button color-blue u-textDecoration-underline--hover"
    (click)="openEditDialog()"
  >
    Tell us more about you
  </button>
</div>
